"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5BTJAKB4cjs = require('../__chunks/5BTJAKB4.cjs');


var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/ZQYY7DF3.cjs');
require('../__chunks/QWIBF3KB.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _MSN6U3HDcjs = require('../__chunks/MSN6U3HD.cjs');


var _K6UHAC73cjs = require('../__chunks/K6UHAC73.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/IRJEBRAW.cjs');
require('../__chunks/W5HIR4GY.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-item-checkbox.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var TagName = "div";
function getPrimitiveValue(value) {
  if (Array.isArray(value)) {
    return value.toString();
  }
  return value;
}
function getValue(storeValue, value, checked) {
  if (value === void 0) {
    if (Array.isArray(storeValue)) return storeValue;
    return !!checked;
  }
  const primitiveValue = getPrimitiveValue(value);
  if (!Array.isArray(storeValue)) {
    if (checked) {
      return primitiveValue;
    }
    return storeValue === primitiveValue ? false : storeValue;
  }
  if (checked) {
    if (storeValue.includes(primitiveValue)) {
      return storeValue;
    }
    return [...storeValue, primitiveValue];
  }
  return storeValue.filter((v) => v !== primitiveValue);
}
var useMenuItemCheckbox = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuItemCheckbox2({
    store,
    name,
    value,
    checked,
    defaultChecked: defaultCheckedProp,
    hideOnClick = false,
    ...props
  }) {
    const context = _XXF5DFSGcjs.useMenuScopedContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component"
    );
    const defaultChecked = _3BSDKDKDcjs.useInitialValue.call(void 0, defaultCheckedProp);
    _react.useEffect.call(void 0, () => {
      store == null ? void 0 : store.setValue(name, (prevValue = []) => {
        if (!defaultChecked) return prevValue;
        return getValue(prevValue, value, true);
      });
    }, [store, name, value, defaultChecked]);
    _react.useEffect.call(void 0, () => {
      if (checked === void 0) return;
      store == null ? void 0 : store.setValue(name, (prevValue) => {
        return getValue(prevValue, value, checked);
      });
    }, [store, name, value, checked]);
    const checkboxStore = _MSN6U3HDcjs.useCheckboxStore.call(void 0, {
      value: _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => state.values[name]),
      setValue(internalValue) {
        store == null ? void 0 : store.setValue(name, () => {
          if (checked === void 0) return internalValue;
          const nextValue = getValue(internalValue, value, checked);
          if (!Array.isArray(nextValue)) return nextValue;
          if (!Array.isArray(internalValue)) return nextValue;
          if (_misc.shallowEqual.call(void 0, internalValue, nextValue)) return internalValue;
          return nextValue;
        });
      }
    });
    props = {
      role: "menuitemcheckbox",
      ...props
    };
    props = _K6UHAC73cjs.useCheckbox.call(void 0, {
      store: checkboxStore,
      name,
      value,
      checked,
      ...props
    });
    props = _5BTJAKB4cjs.useMenuItem.call(void 0, { store, hideOnClick, ...props });
    return props;
  }
);
var MenuItemCheckbox = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuItemCheckbox2(props) {
    const htmlProps = useMenuItemCheckbox(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.MenuItemCheckbox = MenuItemCheckbox; exports.useMenuItemCheckbox = useMenuItemCheckbox;
